import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useRouter } from "vue-router";
import AppShell, { type ShellRoute } from "@/components/layout/AppShell.vue";
import { useAuthService } from "@/services/authService";
import { useAuthStore } from "@/store/AuthStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminMainViewWithAppBar',
  setup(__props) {

const router = useRouter();
const { logout: authLogout } = useAuthService();
const authStore = useAuthStore();
const fullName = computed(() => authStore.fullName);

const mainRoutes = computed<ShellRoute[]>(() => [
  { path: "/admin", name: "Kezdőlap", icon: "mdi-view-dashboard-outline" },
  {
    path: "/admin/accommodationinquiries",
    name: "Szállás igények",
    icon: "mdi-message-text-outline",
  },
  {
    path: "/admin/bookings",
    name: "Foglalások",
    icon: "mdi-calendar-check-outline",
  },
  { path: "/admin/bills", name: "Számlák", icon: "mdi-receipt" },
  {
    path: "/admin/osszesitok",
    name: "Összesítők",
    icon: "mdi-chart-box-outline",
  },
  {
    path: "/admin/ifa-osszesitok",
    name: "IFA összesítők",
    icon: "mdi-chart-line",
  },
  {
    path: "/admin/accommodations",
    name: "Szálláshelyek",
    icon: "mdi-home-city-outline",
  },
  { path: "/admin/companies", name: "Cégek", icon: "mdi-domain" },
]);

async function logout() {
  await authLogout();
  router.push("/admin/login");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppShell, {
    routes: mainRoutes.value,
    "home-path": "/admin",
    "portal-label": "Admin",
    "full-name": fullName.value,
    onLogout: logout
  }, null, 8, ["routes", "full-name"]))
}
}

})